import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { CurrentProfileContext } from '@rma/dashboard/authentication/public/user';
import { SubscriptionTiers } from '@rma/dashboard/generic/domain/to-be-sorted';
import { AvatarComponent } from '@rma/dashboard/generic/ui/avatar';
import { StaticImageUrlPipe } from '@rma/dashboard/generic/util/pipes/static-image-url';
import { ProfileRating } from '@rma/dashboard/profile/public/api-profile-details';
import { isIndividual } from '@rma/generic/domain/helpers';
import { RmaIconComponent } from '@rma/generic/ui/icon';

@Component({
  selector: 'rma-nav-profile-menu',
  templateUrl: './nav-profile-menu.component.html',
  styleUrls: ['./nav-profile-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AvatarComponent, MatTooltipModule, MatExpansionModule, MatButtonModule, RmaIconComponent, RouterModule, TranslocoModule],
  providers: [StaticImageUrlPipe],
})
export class NavProfileMenuComponent {
  private readonly staticImageUrlPipe = inject(StaticImageUrlPipe);

  public readonly userAgency = input<string | null>(null);
  public readonly profile = input<CurrentProfileContext | null>(null);
  public readonly currentPlanName = input<string | null>(null);
  public readonly rating = input<ProfileRating | null>(null);
  public readonly backgroundColour = input<string | null>(null);

  public readonly profileImage = computed(() => {
    const agentPlaceholderImage = 'placeholder/agent.jpg';
    const agencyPlaceholderImage = 'placeholder/agency.jpg';

    const profile = this.profile();

    if (!profile) {
      return this.staticImageUrlPipe.transform(agentPlaceholderImage);
    }

    return (
      profile.profileImage ?? this.staticImageUrlPipe.transform(isIndividual(profile) ? agentPlaceholderImage : agencyPlaceholderImage)
    );
  });

  public readonly isFreePlan = computed(() => this.currentPlanName() === SubscriptionTiers.Free);
}
